import type React from 'react';
import { enableScroll } from '@shared/helpers';
import { LargeHeader } from '@shared/ui';
import { useAppDispatch, useAppSelector } from 'library/hooks/common';
import { selectFrameModal, toggleFrameModal } from 'library/redux/modal';
import ModalLarge from '../ModalLarge';

const ModalFrame: React.FC = () => {
  const dispatch = useAppDispatch();
  const { url } = useAppSelector(selectFrameModal);

  const close = () => {
    enableScroll();
    dispatch(toggleFrameModal({ isOpen: false, url: '' }));
  };

  /**
   * Модальное окно, для демострации каких-либо внешних ресурсов
   * Управляется из redux
   *
   * @url - ссылка на внешний ресурс
   */

  return (
    <ModalLarge isOpen onRequestClose={close} disableHeader>
      <LargeHeader onClose={close} />
      <div style={{ height: 'calc(100% - 70px)', overflow: 'scroll' }}>
        <iframe style={{ height: '100%', width: '100%' }} title="FrameModalIframe" src={url} />
      </div>
    </ModalLarge>
  );
};

export default ModalFrame;
